import { render, staticRenderFns } from "./RegulationTable.vue?vue&type=template&id=e1183e42&scoped=true"
import script from "./RegulationTable.vue?vue&type=script&lang=js"
export * from "./RegulationTable.vue?vue&type=script&lang=js"
import style0 from "./RegulationTable.vue?vue&type=style&index=0&id=e1183e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1183e42",
  null
  
)

export default component.exports